import { ForgotPassword, ResetPassword } from '../pages/PasswordReset'

/** The signed-out pages (D-139), picked by path because nothing signed-out sits inside a router. */
export function publicPageFor(pathname: string): React.ReactElement | null {
  if (pathname === '/forgot-password') return <ForgotPassword />
  if (pathname === '/reset-password') return <ResetPassword />
  return null
}
